(function () {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ValorisationController', ValorisationController);

    ValorisationController.$inject = ['$state', 'Valorisation', 'Technicien', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ValorisationController($state, Valorisation, Technicien, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.search = search;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.filterTechnicien = pagingParams.technicien;
        vm.filterType = pagingParams.type;
        vm.filterAnnee = pagingParams.annee;
        vm.filterSemaine = pagingParams.semaine;

        vm.techniciens = [];
        vm.typeDispo = ['PRIME_OBJECTIF', 'PRIME_REALISEE', 'STAT_TECHNICIEN'];
        vm.yearDispo = [];
        vm.semaineDispo = [];

        loadAll();
        loadTechniciens();
        createArrayOfYear();
        createArrayOfWeek();

        function loadAll() {
            Valorisation.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                technicien: vm.filterTechnicien,
                type: vm.filterType,
                annee: vm.filterAnnee,
                semaine: vm.filterSemaine,
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.valorisations = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function search() {
            vm.page = 1;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                technicien: vm.filterTechnicien,
                type: vm.filterType,
                annee: vm.filterAnnee,
                semaine: vm.filterSemaine,
            });
        }

        function loadTechniciens() {
            Technicien.technicienEnabledHistory({ }, function onSuccess(data) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function createArrayOfYear() {
            var currentDate = new Date();
            for (var i = 2020; i <= currentDate.getFullYear() + 1; i++) {
                vm.yearDispo.push(i);
            }
        }

        function createArrayOfWeek() {
            for (var i = 1; i <= 53; i++) {
                vm.semaineDispo.push(i);
            }
        }
    }

})();
